import type Fuse from "fuse.js";
import React from "react";

interface HighlightedStringProps {
  string: string;
  indices: readonly Fuse.RangeTuple[];
}

export const HighlightedString: FC<HighlightedStringProps> = ({
  string,
  indices,
}) => {
  const strings: React.ReactNode[] = [];

  // Non-matching part at start of string
  const firstIndex = indices[0];
  if (firstIndex) {
    const [firstMatchStart] = firstIndex;
    const prefix = string.substring(0, firstMatchStart);
    if (prefix) {
      strings.push(prefix);
    }
  } else {
    strings.push(string);
  }

  indices.forEach(([matchStart, matchEnd], i) => {
    // Matching part of string
    const match = string.substring(matchStart, matchEnd + 1);
    strings.push(<mark key={`${matchStart}-${matchEnd}`}>{match}</mark>);

    const nextIndex = indices[i + 1];
    if (nextIndex) {
      // Non-matching part between two matches
      const [nextFrom] = nextIndex;
      const nonMatchPart = string.substring(matchEnd + 1, nextFrom);

      if (nonMatchPart) {
        strings.push(nonMatchPart);
      }

      return;
    }

    // Non-matching part at end of string
    const stringRemainder = string.substring(matchEnd + 1, string.length);
    if (stringRemainder) {
      strings.push(stringRemainder);
    }
  });

  return <>{strings}</>;
};
